import { render } from "./BlFormDefer.vue?vue&type=template&id=b21ed0f0"
import script from "./BlFormDefer.vue?vue&type=script&lang=js"
export * from "./BlFormDefer.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/7c12f39a-5a06-429e-8ff2-90249d9b2982/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__